/* eslint-disable import/prefer-default-export */
export const LOGIN = "LOGIN";
